// Birim değişimi etki bandının saf karar yardımcıları (DR5/DR8) — `UnitChangeBand.tsx`'ten taşındı
// (TODO-KPI-101: lib → components import yönü ters olmasın). Bileşen aynı adları yeniden dışa açar.

import type { KpiUnitChangePreview, KpiUnitUsage } from "@mahir/shared";

export type UnitChangeMode = "convert" | "relabel";

export function inUse(p: KpiUnitChangePreview): boolean {
  return p.values > 0 || p.reportedValues > 0 || p.targets > 0;
}

/** Kullanımda + çevrim yolu yok (TL → USD) ya da formül/türetilmiş engeli. */
export function hasUnitBlockers(p: KpiUnitChangePreview): boolean {
  if (p.noop) return false;
  return (
    p.blockers.formulaConflicts.length > 0 ||
    p.blockers.dependents.length > 0 ||
    (p.factor === null && inUse(p))
  );
}

/** Radyo zorunlu mu (DR8): kullanımda + çevrilebilir + gerçek çarpan. */
export function needsUnitMode(p: KpiUnitChangePreview): boolean {
  return !p.noop && !hasUnitBlockers(p) && inUse(p) && p.factor !== null && p.factor !== 1;
}

export function canSave(
  preview: KpiUnitChangePreview | null,
  mode: UnitChangeMode | null,
  state: { loading?: boolean; error?: boolean } = {},
): boolean {
  if (state.loading || state.error || !preview) return false;
  if (preview.noop) return true;
  if (hasUnitBlockers(preview)) return false;
  return needsUnitMode(preview) ? mode !== null : true;
}

export function canSaveCatalog(usage: KpiUnitUsage | null | undefined): boolean {
  return !usage || usage.clients.length === 0;
}
